import { ApolloClient, ApolloLink, HttpLink, InMemoryCache, NormalizedCacheObject } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { getPrefixURL, ProxyGraphClients } from '../../http-client';
import memoize from 'lodash/memoize';

// leaving this out as it breaks pagination.
//Add it back in when we figure out whats actually going on
//
// const cache = new InMemoryCache({
//     typePolicies: {
//         Query: {
//             fields: {
//                 application: {
//                     merge: true,
//                 },
//             },
//         },
//     },
// });
const graphClientUri = '/api/1/graph';
const ansGraphClientUri = getPrefixURL(ProxyGraphClients.ANS) + graphClientUri;
const sxpGraphClientUri = getPrefixURL(ProxyGraphClients.SXP) + graphClientUri;
const apdGraphClientUri = getPrefixURL(ProxyGraphClients.APD) + graphClientUri;
const apdGraphClientUriV2 = getPrefixURL(ProxyGraphClients.APD_V2) + graphClientUri;
const ppcBffGraphClientUri = getPrefixURL(ProxyGraphClients.PPC_BFF) + graphClientUri;
const papiGraphClientUri = getPrefixURL(ProxyGraphClients.PAPI) + '/graphql';

const getAccurateGraphClientUri = (graphClientUri?: string): string => {
  switch (graphClientUri) {
    case ProxyGraphClients.SXP:
      return sxpGraphClientUri;
    case ProxyGraphClients.APD:
      return apdGraphClientUri;
    case ProxyGraphClients.APD_V2:
      return apdGraphClientUriV2;
    case ProxyGraphClients.PPC_BFF:
      return ppcBffGraphClientUri;
    case ProxyGraphClients.PAPI:
      return papiGraphClientUri;
    default:
      return ansGraphClientUri;
  }
};

export const abgGraphqlClient: (_graphClientUri?: string | undefined) => ApolloClient<NormalizedCacheObject> = memoize(
  (graphClientUri?: string) => {
    const currentProxyServiceUri = getAccurateGraphClientUri(graphClientUri);

    return new ApolloClient({
      link: ApolloLink.from([
        onError(({ graphQLErrors, networkError }) => {
          if (graphQLErrors) {
            graphQLErrors.forEach(({ message, locations, path }) =>
              // TODO: Convert this to logging (such as in sentry)
              // eslint-disable-next-line no-console
              console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
            );
          }

          if (networkError) {
            // TODO: Convert this to logging (such as in sentry)
            // eslint-disable-next-line no-console
            console.log(`[Network error]: ${networkError}`);
          }
        }),
        new HttpLink({
          uri: currentProxyServiceUri,
          credentials: 'same-origin',
          fetch,
        }),
      ]),
      cache: new InMemoryCache(),
      connectToDevTools: true,
      defaultOptions: {
        watchQuery: {
          // Set all queries to no-cache to ensure the latest data
          fetchPolicy: 'no-cache',
          nextFetchPolicy: 'no-cache',
          // Change the loading state if the query starts another fetch
          notifyOnNetworkStatusChange: true,
          errorPolicy: 'all',
        },
        query: {
          errorPolicy: 'all',
        },
        mutate: {
          errorPolicy: 'all',
        },
      },
    });
  }
);
